var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-main-view",
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "embroidery-main-view-title text-center",
      "elementType": "h5",
      "keyTranslation": "embroideryMainViewStep"
    }
  }), _c('CustomText', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.isPersonalizationInvalid,
      expression: "!!isPersonalizationInvalid"
    }],
    attrs: {
      "elementType": "span",
      "keyTranslation": "transferDesignEmbroideryDesc"
    }
  }), _c('EmbroideryImagesView', {
    attrs: {
      "itemsToPersonalize": _vm.itemsToPersonalize
    },
    on: {
      "images-loaded": _vm.imagesLoaded
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "row"
    }
  }, [_c('CustomInput', {
    attrs: {
      "data-slide-id": "0",
      "id": "input-text-personalization-left",
      "labelClass": "embroidery-main-view-label",
      "name": "personlization-input-left",
      "type": "text",
      "containerClass": ['small-8', 'large-6', 'small-centered', 'columns', {
        'large-uncentered': _vm.itemsToPersonalize > 1
      }, 'tooltip-container'],
      "customClass": ['embroidery-main-view-input', 'uppercase', {
        'error-moderation': _vm.showModerationMessage0
      }],
      "label": _vm.itemsToPersonalize > 1 ? _vm.translations.embroideryLeftShoeLabel : _vm.translations.embroideryBackpackLabel,
      "maxlength": _vm.maxLength(0)
    },
    on: {
      "input": _vm.validateInputText
    },
    model: {
      value: _vm.message0,
      callback: function callback($$v) {
        _vm.message0 = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "message0"
    }
  }, [_c('CustomTooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showModerationMessage0,
      expression: "showModerationMessage0"
    }],
    attrs: {
      "customsClasses": "tooltip-embroidery-modal label-input"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moderationMessage)
    }
  })])], 1), _vm.itemsToPersonalize > 1 ? _c('CustomInput', {
    attrs: {
      "containerClass": "small-8 large-6 small-centered large-uncentered columns tooltip-container",
      "data-slide-id": "1",
      "id": "input-text-personalization-right",
      "labelClass": "embroidery-main-view-label",
      "name": "personlization-input-right",
      "type": "text",
      "customClass": ['embroidery-main-view-input', 'uppercase', {
        'error-moderation': _vm.showModerationMessage1
      }],
      "label": _vm.translations.embroideryRightShoeLabel,
      "maxlength": _vm.maxLength(1)
    },
    on: {
      "input": _vm.validateInputText
    },
    model: {
      value: _vm.message1,
      callback: function callback($$v) {
        _vm.message1 = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "message1"
    }
  }, [_c('CustomTooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showModerationMessage1,
      expression: "showModerationMessage1"
    }],
    attrs: {
      "customsClasses": "tooltip-embroidery-modal label-input"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moderationMessage)
    }
  })])], 1) : _vm._e()], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-main-view-alpha-num text-center"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.personalizeAlphaNum) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }